

 
@if (showdropDown) {

<section class="searchBarContainer d-flex" >

  <select class="form-select select-searchbar" aria-label="Default select example">
    <option  class="text-primary">Company</option>
  </select>
    <mat-select [formControl]="companies" class="form-control " multiple>
        @for (company of companyList; track company) {
          <mat-option   #matOption (click)="foo($event)"[value]="company">{{company.companyName}}</mat-option>
        }
      </mat-select>
</section>
}